import { render, staticRenderFns } from "./tongdao.vue?vue&type=template&id=54e5e120&scoped=true&"
import script from "./tongdao.vue?vue&type=script&lang=js&"
export * from "./tongdao.vue?vue&type=script&lang=js&"
import style0 from "./tongdao.vue?vue&type=style&index=0&id=54e5e120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e5e120",
  null
  
)

export default component.exports